module.exports = __webpack_public_path__ + "img/Gallery_2_29.93e83232.jpeg";